/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineRentalDetailModel
 */
export interface MachineRentalDetailModel {
    /**
     * 
     * @type {Date}
     * @memberof MachineRentalDetailModel
     */
    modifiedDate?: Date | null;
}

export function MachineRentalDetailModelFromJSON(json: any): MachineRentalDetailModel {
    return MachineRentalDetailModelFromJSONTyped(json, false);
}

export function MachineRentalDetailModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineRentalDetailModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
    };
}

export function MachineRentalDetailModelToJSON(value?: MachineRentalDetailModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
    };
}

